import { defineNuxtPlugin, useRuntimeConfig, useState, useRouter } from 'nuxt/app';

type WindowWithRollbar = Window & {
	rollbar?: new (config: Record<string, unknown>) => {
		error: (error: Error, extra?: Record<string, unknown>) => void;
	};
	rollbarIgnore?: (isUncaught: boolean, args: unknown, payload: unknown) => boolean;
};

export default defineNuxtPlugin((nuxtApp) => {
	const config = useRuntimeConfig();
	const rollbarTokenState = useState<string>('rollbarClientToken');
	const token = rollbarTokenState.value || config.public.rollbarClientToken;

	if (!token) return;

	const windowWithRollbar = window as WindowWithRollbar;

	if (!windowWithRollbar.rollbar) return;

	const rollbar = new windowWithRollbar.rollbar({
		accessToken: token,
		captureUncaught: true,
		captureUnhandledRejections: true,
		payload: {
			environment: config.public.appEnv as string
		},
		checkIgnore: windowWithRollbar.rollbarIgnore
	});

	const existingHandler = nuxtApp.vueApp.config.errorHandler;

	nuxtApp.vueApp.config.errorHandler = (error, instance, info): void => {
		rollbar.error(error as Error, { info });
		existingHandler?.(error, instance, info);
	};

	nuxtApp.hook("app:error", (error): void => {
		rollbar.error(error as Error);
	});

	nuxtApp.provide("rollbar", rollbar);

	try {
		const router = useRouter();
		router.onError((error: Error) => {
			rollbar.error(error);
		});
	} catch {
		console.warn('[Rollbar] Could not attach router error handler');
	}
});
